<template>
    <div>
        <div class="pull-right">
            <button class="btn btn-xs btn-danger" @click="confirmDelete" :disabled="loading" v-if="$can('manage-product-bans')">
                <span class="fa fa-trash"></span>
                Delete
            </button>
        </div>

        <div>
            Added
            <template v-if="productBan.user">by {{ productBan.user.full_name }}</template>
            at {{ productBan.created_at | dateTime }}
        </div>
        <div class="nl2br" style="margin: 0 0 10px 20px">{{ productBan.notes }}</div>
    </div>
</template>

<script>
import { generateIndexRowMixins } from '@/utilities/crud/mixins';
export default {
    mixins: [
        generateIndexRowMixins({
            entity: 'productBans',
            deleteConfirmationTitle: 'Delete this ban?',
            deleteConfirmationText: productBan => `The ban will be deleted.`,
        }),
    ],
    methods: {
        postDelete() {
            this.$emit('deleted');

            // Quick hack to reload vendor inventory page data
            let handler = this.$route.matched[0].instances.default.updateData;
            if (handler) {
                handler();
            }
        },
    },
}
</script>
